import WhyPDFServicesAPI from "../../../../src/pages/apis/pdf-services/why-pdf-services-api.md";
import KeyFeaturesCodeBlock from "../../../../src/pages/apis/pdf-services/key-features-code-block.md";
import AWSMSCarousel from "../../../../src/pages/apis/pdf-services/aws-ms-carousel.md";
import StartModifyingPDF from "../../../../src/pages/apis/pdf-services/start-modifying-pdf.md";
import UseCasesResourceCard from "../../../../src/pages/apis/pdf-services/use-cases-resource-cards.md";
import DocumentServicesProductCards from "../../../../src/pages/apis/pdf-services/document-services-product-cards.md";
import AdobePDFExtractAPI from "../../../../src/pages/apis/pdf-services/adobe-pdf-extract-api.md";
import { APIPixelRetargeting } from "../../../../src/components/retargetting";
import { NewsLetterBlade } from "../../../../src/components/news-letter-blade";
import EsealApiAnnouncement from "../../../../src/pages/apis/e-seal-api-announcement.md";
import * as React from 'react';
export default {
  WhyPDFServicesAPI,
  KeyFeaturesCodeBlock,
  AWSMSCarousel,
  StartModifyingPDF,
  UseCasesResourceCard,
  DocumentServicesProductCards,
  AdobePDFExtractAPI,
  APIPixelRetargeting,
  NewsLetterBlade,
  EsealApiAnnouncement,
  React
};